import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import User from '../entities/user';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Util from '../../lib/utils';

interface UserState extends ListState<User> {
    editUser: User;
    userInfo: any;
    canRegister: boolean;
}
class UserModule extends ListModule<UserState, any, User> {
    enshopid = Util.siss.auth.getenshopid();
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<User>(),
        loading: false,
        editUser: new User(),
        // userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},
        userInfo: localStorage[this.enshopid + '_userInfo'] ? JSON.parse(localStorage[this.enshopid + '_userInfo']) : {},
        servicebranch: sessionStorage.servicebranch ? JSON.parse(sessionStorage.servicebranch == "undefined" ? null : sessionStorage.servicebranch) : {},
        loginstate: sessionStorage[this.enshopid + '_loginstate'] ? JSON.parse(sessionStorage[this.enshopid + '_loginstate']) : {},
        canRegister: false,
        chatredBysaleman: "",
        chatredByvip: "",
        showlive: false,
        scrolltop: 0,
        livefontcolor: '',
        livebuttoncolor: '',
        userBalance: sessionStorage[this.enshopid + '_userBalance'] ? JSON.parse(sessionStorage[this.enshopid + '_userBalance']) : {},
        userScore: sessionStorage[this.enshopid + '_userScore'] ? JSON.parse(sessionStorage[this.enshopid + '_userScore']) : {},
        addressfrom: "",
        vouhcer: {},
        kefustate: '',
        registerLastRouter: localStorage[this.enshopid + '_registerLastRouter'] ? JSON.parse(localStorage[this.enshopid + '_registerLastRouter']) : {},
        shopinfo: ''
    };
    // public getters = {
    //     userBalance: (state) => {
    //         let total = 0;
    //         state.currentGoodsList.forEach((item) => {
    //             total += item.Price * item.Count;
    //         });
    //         return total;
    //     },
    // };
    public actions = {
        async getAll(context: ActionContext<UserState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/UserSetting/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<User>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getchargefeediscount(payload: any) {
            const reponse = await Ajax.get('/api/services/app/RechargeDiscount/GetRechargeDiscountList');
            return reponse.data.result;
        },
        async checkNet(payload: any) {
            const reponse = await Ajax.post('/api/services/app/CheckHelper/CheckNet', payload.data);
            return reponse.data.result;
        },
        async getchargefeeblance(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/T_Chargefee/GetRechargeBlance');
            return reponse.data.result;
        },
        async getsendchargefeeblance(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/T_Chargefee/GetSendChargeFeeSum');
            return reponse.data.result;
        },
        async getchargefeehistory(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/T_Chargefee/GetChargeFeeHistoryList', { params: payload.data });
            return reponse.data.result;
        },
        async chargefee(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/T_Chargefee/ChargeFee', payload.data);
            return reponse.data.result;
        },
        async getvouchercenter(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetVoucherCenter');
            return reponse.data.result;
        },
        async getvoucherlist(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetVoucherDetailList?vipopenid=');
            return reponse.data.result;
        },
        async getvoucherright(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetVoucherRight?voucherid=' + payload.data.voucherid);
            return reponse.data.result;
        },
        async getvoucher(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetVoucher?voucherid=' + payload.data.voucherid);
            return reponse.data.result;
        },
        /**
         * 获取优惠券详情
         * @param context 
         * @param payload  优惠券ID
         */
        async getvoucherdetail(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetVoucherDetail?id=' + payload.data.id);
            return reponse.data.result;
        },
        async getvouchercode(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetVoucherCode?voucherid=' + payload.data.voucherid);
            return reponse.data.result;
        },
        async getcheckvoucher(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetCheckVoucher?voucherid=' + payload.data.voucherid);
            return reponse.data.result;
        },
        async getcheckvoucherbyids(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/DiscountVoucher/GetCheckVoucherByIds?voucherid=' + payload.data.voucherid);
            return reponse.data.result;
        },
        async getbranchlist(context: ActionContext<UserState, any>, payload: any) {

            let use_branchs = "";
            if (payload.data.use_branchs) {
                use_branchs = payload.data.use_branchs;
            }
            const reponse = await Ajax.get('/api/services/app/Branch/GetDefaultBranchList?use_branchs=' + use_branchs);
            return reponse.data.result;
        },
        async setdefaultbranch(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Branch/SetDefaultBranch', payload.data);
            return reponse.data.result;
        },
        async getcheckinfo(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/WxCheckIn/GetCheckInfo');
            return reponse.data.result;
        },
        async postcheckin(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/WxCheckIn/PostCheckIn', payload.data);
            return reponse.data.result;
        },
        async getvipinfo(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/VipInfo/GetVipInfo');
            context.state.editUser = reponse.data.result.wxavipinfo || reponse.data.result.vipinfo;
            return reponse.data.result;
        },
        async updatevipinfo(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.put('/api/services/app/VipInfo/UpdateVipInfo', payload.data);
            return reponse.data.result;
        },
        async getcardbyphoneoffline(context: ActionContext<UserState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/VipInfo/GetCardByPhoneOffline?phone=' + payload.data.phone);
            return reponse.data.result;
        },
        async editcardpwd(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/EditCardPwd', payload.data);
            return reponse.data.result;
        },
        async changepwdbyphone(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/ChangePwdByPhone', payload.data);
            return reponse.data.result;
        },
        async getuserinforights(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/VipInfo/GetUserInfoRights', payload.data);
            return reponse.data.result;
        },
        async getuserinforights2(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/VipInfo/GetUserInfoRights2', payload.data);
            return reponse.data.result;
        },
        async rebindcard(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/VipInfo/ReBindCard');
            return reponse.data.result;
        },
        async getIsShowBranch(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/BasicSet/GetBasicsetShowBranch');
            return reponse.data.result;
        },
        async getPayCode(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/VipInfo/GetPayCode');
            return reponse.data.result;
        },
        async getTypeName(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/VipInfo/getTypeName');
            return reponse.data.result;
        },
        async getDefaultPay(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/BasicSet/GetBasicsetPayType?orderNo='+payload.data.orderNo);
            return reponse.data.result;
        },
        async getvoucherbagdetail(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/VoucherBag/GetVoucherBagDetail?id=' + payload.data.id);
            return reponse.data.result;
        },
        async checknewComment(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/VipInfo/ChecknewComment');
            return reponse.data;
        },
        async saveCurrentUrl(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/SaveCurrentUrl', payload.data);
            return reponse.data.result;
        },
        //用户授权公众号
        async userWxghOauth(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/WxOpen/UserOAuth', payload.data);
            return reponse.data.result;
        },
        /**
         * 获取用户授权公众号后的openid
         * @param context 
         * @param payload 
         */
        async bindWxghOpenid(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/BindWxghOpenid', payload.data);
            return reponse.data.result;
        },
        //判断用户是否绑定了公众号
        async isBindWxgh(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/IsBindWxgh', payload.data);
            return reponse.data.result;
        },
        //查询卡密
        async querykami(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/PwdVoucher/QueryPwdVoucher', payload.data);
            return reponse.data.result;
        },
        //使用卡密
        async usekami(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('api/services/app/PwdVoucher/UsePwdVoucher', payload.data);
            return reponse.data.result;
        },
        async updateUserShareOpenId(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.put('/api/services/app/ShareRegisterGift/UpdateUserShareOpenId2?shareopenid=' + payload.data.shareopenid);
            return reponse.data.result;
        },
        async bindBossAssistantAdmin(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/BossAssistant/BindBossAssistantAdmin', payload.data);
            return reponse.data.result;
        },
        async bindBossAssistantAdmin2(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/BossAssistant/BindBossAssistantAdmin2', payload.data);
            return reponse.data.result;
        },
        /**
         * 激活微信会员卡（获取数据，不激活）
         * @param context 
         * @param payload 
         */
        async activateWxCard(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Wxapp/ActivateWxCard', payload.data);
            return reponse.data.result;
        },
        /**
         * 获取订单信息（老板助手模板消息推送）
         * @param context 
         * @param payload 
         */
        async getBossOrderDetail(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Wxapp/OrderDetail', payload.data);
            return reponse.data.result;
        },
        async getVipHasCard(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/VipInfo/getVipHasCard');
            return reponse.data.result;
        },
        /**
   * 激活微信会员卡（用户在绑定或者注册微商店会员后再调用）
   * @param context 
   * @param payload 
   */
        async memberCardActivate(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/Wxapp/MemberCardActivate', payload.data);
            return reponse.data.result;
        },
        /**
      * 根据手机号获取线下卡号信息 （未登陆状态获取）
      * @param context 
      * @param payload 
      */
        async getCardIdList(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Wxapp/GetCardIdList?shopid=' + payload.data.shopid + '&phone_no=' + payload.data.phone_value + '&wxapp_openid=' + payload.data.wxapp_openid);
            return reponse.data.result;
        },

        /** 
   * 绑定会员卡（未登陆状态获取）
   * @param context 
   * @param payload 
   */
        async bindCardId(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/WxaBind', payload.data);
            return reponse.data.result;
        },
        /** 
* 注册会员卡（未登陆状态获取）
* @param context 
* @param payload 
*/
        async regCardId(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/WxaRegister', payload.data);
            return reponse.data.result;
        },
        async setMigration(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/VipInfo/SetVipinfoAndVoucherFrom25', payload.data);
            return reponse.data.result;
        },
        async rechargediscount(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/RechargeDiscount/GetExistRechargeDiscount');
            return reponse.data.result;
        },
        //活动隔离-满减
        async saveCurrentUrl_MobileBuyFull(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileBuyFull/SaveCurrentUrl', payload.data);
            return reponse.data.result;
        },
        //活动隔离-满减
        async checkNet_MobileBuyFull(payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileBuyFull/CheckNet', payload.data);
            return reponse.data.result;
        },
        //活动隔离-拼团
        async saveCurrentUrl_MobilePintuan(context: ActionContext<UserState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobilePintuan/SaveCurrentUrl', payload.data);
            return reponse.data.result;
        },
        //活动隔离-拼团
        async checkNet_MobilePintuan(payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobilePintuan/CheckNet', payload.data);
            return reponse.data.result;
        },
        async getWxaUserIdByOpenId(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/VipInfo/GetWxaUserIdByOpenId');
            return reponse.data.result;
        },
        async setWxaUserShareOpenId(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/ShareRegisterGift/SetWxaUserShareOpenId2?shareopenid='+payload.data.shareopenid);
            return reponse.data.result;
        },
        async getWxaUserShareOpenId(context: ActionContext<UserState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ShareRegisterGift/GetWxaUserShareOpenId');
            return reponse.data.result;
        },
    };
    public mutations = {
        setShopid(state, payload) {
            state.shopinfo = payload
        },
        setState(state, payload) {
            for (let key in payload) {
                state[key] = payload[key]
            }
        },
        setCurrentPage(state: UserState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: UserState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: UserState, User: User) {
            state.editUser = User;
        },
        setUserInfo(state, User) {
            state.userInfo = User;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + "_userInfo", JSON.stringify(User));
        },
        setUserInfoByKey(state: UserState, obj: any) {
            const enshopid = Util.siss.auth.getenshopid();
            state.userInfo[obj.key] = obj.value;
            let user = JSON.parse(localStorage.getItem(enshopid + "_userInfo"))
            user[obj.key] = obj.value;
            localStorage.setItem(enshopid + "_userInfo", JSON.stringify(user))
        },
        setServiceBranch(state, data) {
            const { branch_no, branch_name, latitude, longitude } = data;
            state.servicebranch.branch_no = branch_no;
            state.servicebranch.branch_name = branch_name;
            state.servicebranch.latitude = latitude;
            state.servicebranch.longitude = longitude;
            sessionStorage.setItem("servicebranch", JSON.stringify(state.servicebranch));
        },
        setLoginState(state, data) {
            const enshopid = Util.siss.auth.getenshopid();
            state.loginstate = data;
            sessionStorage.setItem(enshopid + "_loginstate", data);
        },
        setCanRegister(state, data) {
            state.canRegister = data;
        },
        setChatRed(state, data) {
            state[data.key] = data.value;
        },
        setUserBalance(state, data) {
            const { balance, states } = data;
            state.userBalance.balance = balance;
            state.userBalance.states = states;
            const enshopid = Util.siss.auth.getenshopid();
            sessionStorage.setItem(enshopid + "_userBalance", JSON.stringify(data));
        },
        setUserScore(state, data) {
            const { score, states } = data;
            state.userScore.score = score;
            state.userScore.states = states;
            const enshopid = Util.siss.auth.getenshopid();
            sessionStorage.setItem(enshopid + "_userScore", JSON.stringify(data));
            // sessionStorage.setItem("loginstate", data);
        },
        setshowlive(state, data) {
            state.showlive = data
        },
        setlivefontcolor(state, data) {
            state.livefontcolor = data
        },
        setscrollTop(state, data) {
            state.scrolltop = data;
        },
        setVoucher(state, data) {
            state.voucher = data;
        },
        setKefustate(state, data) {
            state.kefustate = data;
        },
        setRegisterLastRouter(state, data) {
            state.registerLastRouter = data;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + "_registerLastRouter", JSON.stringify(data));
        },
    };
}
const userModule = new UserModule();
export default userModule;
